module.exports = __webpack_public_path__ + "media/images/pin-0eaad561fec1d02df7150f6d61f8fe7a.png";